import React, { useState, useEffect } from 'react'
import { Table, Modal } from "antd";
import MessageApi from '@api/message'
import { connect } from 'react-redux'
import Pover from '@/components/Pover'
import Title from '@/components/Title'
import { forecastApi } from "@api/newApi";

import './style.scss'
import { toComparators } from 'semver';
const Pages = ({ history, dispatch, searchArgs }) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([]) // 表格数据
  const [grade, setGrade] = useState([])//处理完成是否
  const [searchParams, setSearchParams] = useState({
    forecastGrade: null,
    monitorType: null,
    pageNum: 1,
    pageSize: 10,
    type: 1
  })
  useEffect(() => {
    getAiList()
    return () => { }
  }, [searchParams])
  // 分页
  const handleTableChange = (pagination) => {
    let params = {
      ...searchParams,
      pageNum: pagination.current,
      pageSize: pagination.pageSize,
    }
    // dispatch(setStateSearchParams(params))
    setSearchParams(params)
  };

  //获取DOM元素
  const getAiList = () => {
    setLoading(true)
    forecastApi.selectForecastByPage({ ...searchParams })
      .then((res) => {
        setLoading(false)
        if (res.status == 0) {
          setData(res.data)
        }
      })
  }
  /**
   * table配置
   * @type {*[]}
   */

  const columns = [
    {
      title: '厂站',
      dataIndex: 'stationName',
      align: 'center',
      width: 200,
      key: 'index',
      render: (text, record, index) => {
        return (
          <div>
              <span className={record.handleStatus == 1 ? 'WCL' :'YWC'}>
                {record.handleStatus == 1 ?'未处理' : '已完成'}
              </span>
              <span>
                {
                  text
                }
              </span>
          </div>
        )
      }
    },
    {
      title: '故障描述',
      dataIndex: 'forecastInfo',
      key: 'typeId',
      align: 'center',
      width: 200
    },
    {
      title: '开始时间',
      dataIndex: 'startTime',
      align: 'center',
      key: 'title',
      //render: text => Pover(text, 14)
    },
    {
      title: '责任人',
      dataIndex: 'dutyUserNames',
      align: 'center',
      key: "sendTime",
      width: 200,
    },
    {
      title: '风险等级',
      dataIndex: 'forecastGrade',
      align: 'center',
      key: 'status',
      render: (obj) => {
        return (
          <span className={obj == 1 ? 'greeMark' : obj == 2 ? 'yellowMark' : 'redMark'}>
            {
              obj == 1 ? '低' : obj == 2 ? '中' : '高'
            }
          </span>)
      }
    }
  ]

  return (
    <div className='AI' style={{ position: 'relative' }}>
      <Title title="AI预警"></Title>
      <div className='ptable'>
        <div>
          <Table
            columns={columns}
            dataSource={data.data}
            rowKey={record => record.id}
            pagination={{
              current: data.pageNum,
              pageSize: data.pageSize,
              showQuickJumper: true,
              showSizeChanger: true,
              showTotal: total => `共${total}条数据`,
              total: data.total
            }}
            onChange={handleTableChange}
            loading={loading}
          />
        </div>
      </div>
    </div >
  )
}

export default Pages